<template>
  <SectionSplit
    id="SectionOptimisedSystem"
    class="full-image reverse"
    :headline="$t('headline')"
    src="../../assets/optimised-system.jpg">
    <p>
      {{ $t('text') }}
    </p>
    <Btn :to="ctaTo">
      {{ $t('cta') }}
    </Btn>
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
  props: {
    ctaTo: Object,
  },
}
</script>

<style lang="scss">
#SectionOptimisedSystem {
  background-color: $white;

  p {
    color: $black;
    font-size: $h4;
  }
}
</style>

<i18n>
{
  "lt": {
    "headline": "Optimizuota (išmani) sistema",
    "text": "Nogrid vieni pirmųjų Lietuvos rinkoje pradėjo prekiauti ir siūlyti optimizuotą (išmanią) įrangą. Ji yra iki 25% efektyvesnė ir saugesnė nei standartinės sistemos.",
    "cta": "Gaukite pasiūlymą"
  }
}
</i18n>
